import { render, staticRenderFns } from "./KnowledgeUnitChartDetails.vue?vue&type=template&id=0db4d032&"
import script from "./KnowledgeUnitChartDetails.vue?vue&type=script&lang=js&"
export * from "./KnowledgeUnitChartDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports